var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tracks from '.';
import Element from './Element';
var Track = function (props) {
    var time = props.time, elements = props.elements, isOpen = props.isOpen, tracks = props.tracks, clickElement = props.clickElement;
    return (_jsxs("div", __assign({ className: "tr-track" }, { children: [_jsx("div", __assign({ className: "rt-track__elements" }, { children: elements
                    .filter(function (_a) {
                    var start = _a.start, end = _a.end;
                    return end > start;
                })
                    .map(function (element) {
                    var classes = element.classes, elementClickElement = element.clickElement, dataSet = element.dataSet, end = element.end, id = element.id, altId = element.altId, start = element.start, style = element.style, elementTime = element.time, title = element.title, titleStyle = element.titleStyle, tooltip = element.tooltip, tooltipFollowCursor = element.tooltipFollowCursor, tooltipStyle = element.tooltipStyle, continuing = element.continuing;
                    var selectedTime = elementTime || time;
                    var selectedClickElement = elementClickElement || clickElement;
                    return (_jsx(Element, { classes: classes, clickElement: selectedClickElement, dataSet: dataSet, end: end, start: start, style: style, time: selectedTime, title: title, titleStyle: titleStyle, tooltip: tooltip, tooltipStyle: tooltipStyle, tooltipFollowCursor: tooltipFollowCursor, id: id, altId: altId, continuing: continuing }, id));
                }) })), isOpen && tracks && tracks.length > 0 && _jsx(Tracks, { time: time, tracks: tracks, clickElement: clickElement })] })));
};
export default Track;
